// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CreditMemo } from './credit-memo';
import { JoDetail } from './jo-detail';
import { ReturnReasonType } from './return-reason-type';
import { ReturnRequest } from './return-request';
import { ReturnRequestDetailStatus } from './return-request-detail-status';
import { ReturnReasonTypeEnum } from './enums';
import { ReturnRequestDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import _ from "lodash";
import { EntityPropertyAnnotation, EntityTypeAnnotation } from "../entity-type-annotation";
import { ItemDetail } from "./item-detail";
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReturnRequestDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // requires that associated JoDetail and JoDetailAddon records have been retrieved from the db
  calcDefaultCreditMemoAmt() {
    const jod = this.joDetail;
    const jodaTotal = _.sum(jod.joDetailAddons.map((joda) => joda.unitPriceAmt * this.qty));
    const creditMemoAmt = jod.unitTotalAmt * this.qty + jodaTotal;
    return creditMemoAmt;
  }

  // temporary holding place for ItemDetails
  returnedItemDetails: ItemDetail[];

  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation("qty", {
        validators: [BaseEntity.greaterThanZeroValidator],
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Decimal */
  actualUnitCreditAmt?: number;
  /** Boolean */
  chargeRestockFee!: boolean;
  /** Boolean */
  creditAccountOwnedReturns!: boolean;
  /** String(30) */
  decision?: string;
  /** String */
  decisionNotes?: string;
  /** Decimal */
  defaultUnitCreditAmt?: number;
  /** Boolean */
  includePrepaidLabel!: boolean;
  /** DateTimeOffset */
  inspectedTs?: Date;
  /** Int32 FK joDetail */
  joDetailId!: number;
  /** DateTimeOffset */
  ledgerReportedTs?: Date;
  /** String(20) */
  phase?: string;
  /** String(4) */
  phaseUpdatedBy?: string;
  /** DateTimeOffset */
  phaseUpdatedTs?: Date;
  /** String */
  processNotes?: string;
  /** Guid */
  proximityOrigReturnRequestDetailId?: string;
  /** Guid */
  proximityReturnRequestDetailId?: string;
  /** Int32 */
  qty!: number;
  /** Int32 */
  receivedQty?: number;
  /** DateTimeOffset */
  receivedTs?: Date;
  /** String */
  reconciliationExplanation?: string;
  /** Boolean */
  restockFeeInvoiced!: boolean;
  /** String */
  returnExplanation!: string;
  /** Enum FK returnReasonType */
  returnReasonTypeId!: ReturnReasonTypeEnum;
  /** Enum FK returnRequestDetailStatus */
  returnRequestDetailStatusId!: ReturnRequestDetailStatusEnum;
  /** Int32 FK returnRequest */
  returnRequestId!: number;
  /** String */
  returnStatusExplanation?: string;
  /** DateTimeOffset */
  returnStatusdTs!: Date;
  /** DateTimeOffset */
  routedTs?: Date;
  /** DateTimeOffset */
  settledTs?: Date;
  /** Inv FK returnRequestDetailId */
  creditMemos!: CreditMemo[];
  /** FK joDetailId */
  joDetail!: JoDetail;
  /** FK returnReasonTypeId */
  returnReasonType!: ReturnReasonType;
  /** FK returnRequestId */
  returnRequest!: ReturnRequest;
  /** FK returnRequestDetailStatusId */
  returnRequestDetailStatus!: ReturnRequestDetailStatus;
}

